import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtmlCode',
  pure: true
})
export class StripHtmlCodePipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    return this.stripHtmlCode(value);
  }

  stripHtmlCode(html: string): string {
    return ((html?.length === 0 )? '' : html.replace(/<[^>]+>([^<]+)?/gm, '$1 ').trim());
  }


}
